var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c("SideBar"),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "v-container",
            { staticClass: "main" },
            [_c("RouterView", { key: _vm.$route.path })],
            1
          )
        : _c("Spinner"),
      _vm._v(" "),
      _c("AppFooter")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }